import { InputField } from 'react-formatge'
import type { FormUpdatePayload } from 'react-formatge/dist/esm/types'

export * from './forms'
export * from './components'

export { InputField, type FormUpdatePayload }
